import React, { Component, Fragment } from 'react'
import TopNavigation from '../components/TopNavigation/header';
import PageTop from '../components/PageTop/PageTop';
import AllProjects from '../components/AllProjects/AllProjects';
import Footer from '../components/Footer/Footer';

export class AllProjectsPage extends Component {

  componentDidMount(){
    window.scroll(0,0);
  }



  render() {
    return (
      <Fragment>
        <TopNavigation></TopNavigation>
        <PageTop pageTitle="Upcoming Events"></PageTop>
        <AllProjects></AllProjects>
       <Footer></Footer>
      </Fragment>
    )
  }
}

export default AllProjectsPage
